import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { globals } from '../globals';
import { UploadService } from './upload.service';

@Injectable({
  providedIn: 'root'
})
export class ArquivoPropostaService {

  constructor(
    private http: HttpClient,
    private uploadService: UploadService) {}

  public consultarArquivosProposta(idLoja?: number) {
    const controller = idLoja !== undefined && idLoja !== null ? 'ArquivoPropostaLoja' : 'ArquivoProposta';
    const query = idLoja !== undefined && idLoja !== null ? '?idLoja=' + idLoja : '';
    return this.http.get<any>(globals.apiUrl + '/api/' + controller + '/BuscarArquivosProposta' + query);
  }

  public consultarVariaveis() {
    return this.http.get<any>(globals.apiUrl + '/api/ArquivoProposta/BuscarVariaveis');
  }

  public enviarArquivoProposta(tipo, formData, idLoja?: number) {
    const controller = idLoja !== undefined && idLoja !== null ? 'ArquivoPropostaLoja' : 'ArquivoProposta';
    const query = idLoja !== undefined && idLoja !== null ? '&idLoja=' + idLoja : '';
    return this.uploadService.upload(formData, globals.apiUrl + '/api/' + controller + '/SalvarArquivoProposta?tipo=' + (tipo === 'pedido' ? '1' : '0') + query);
  }

  public baixarModelo() {
    return this.http.get(globals.apiUrl + '/api/ArquivoProposta/BaixarModelo', { responseType: 'blob' });
  }

  public baixarPorTipo(tipo, idLoja?: number) {
    const controller = idLoja !== undefined && idLoja !== null ? 'ArquivoPropostaLoja' : 'ArquivoProposta';
    const query = idLoja !== undefined && idLoja !== null ? '&idLoja=' + idLoja : '';
    return this.http.get(globals.apiUrl + '/api/' + controller + '/BaixarArquivoProposta?tipo=' + (tipo === 'pedido' ? '1' : '0') + query, { responseType: 'blob' });
  }

  public excluirPorTipo(tipo, idLoja?: number) {
    const controller = idLoja !== undefined && idLoja !== null ? 'ArquivoPropostaLoja' : 'ArquivoProposta';
    const query = idLoja !== undefined && idLoja !== null ? '&idLoja=' + idLoja : '';
    return this.http.get(globals.apiUrl + '/api/' + controller + '/ExcluirArquivoProposta?tipo=' + (tipo === 'pedido' ? '1' : '0') + query);
  }

}
